import { Slide, LinkInfo } from './types';

export const gameSlides: Slide[] = [
    {
        image: './images/lastKeyOfRobotica3.jpg',
        url: '/games/lastkeyofrobotica3',
    },
    { image: './images/avarice.jpg', url: '/games/avarice' },
    { image: './images/wompatron9000.jpg', url: '/games/wompatron9000' },
    { image: './images/writerUnblocked.jpg', url: '/games/writerunblocked' },
];

export const mainNav: LinkInfo[] = [
    {
        title: 'Our Games',
        url: '/games',
    },
    {
        title: 'Our Company',
        url: '/about',
    },
    {
        title: 'Career',
        url: '/career',
    },
    {
        title: 'Contact',
        url: '/contact',
    },
];
